export default "__VITE_ASSET__DT57oZFk__"